import { NgIf, NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { AdminService } from '../../../../services/admin.service';
import { CommonService } from '../../../../services/common.service';
import { NotificationService } from '../../../../services/notification.service';

@Component({
    selector: 'app-manage-material-service',
    imports: [NextPage, TableModule, NgIf, NgClass, ButtonModule, FormsModule],
    templateUrl: './manage-material-service.component.html',
    styleUrl: './manage-material-service.component.scss'
})
export class ManageMaterialServiceComponent {
  materialData: any = []
  exportData: any = []
  newMaterialState: any = ''
  ListingPriority = ''
  SaveSuccess = false;
  errorData = false;
  isLoading: boolean = false;

  constructor(private adminService: AdminService, private commonService: CommonService,private messageService: NotificationService) {
    this.isLoading = true;

    this.setMaterialData();
  }

  setMaterialData() {
    this.isLoading = true;
    this.adminService.getAllUserInteractions('ManageMaterialState').subscribe((response: any) => {
      this.materialData = response;
      this.setExportData(response);
      this.processData();
    });
  }


  setExportData(data: any) {
    this.exportData = data.map((item: any) => ({
      RecID: item.RecID,
      FacilityID: item.FacilityID,
      MaterialStateName: item.MaterialStateName,
      MaterialStatePriority: item.MaterialStatePriority,
      MaterialStateRetired: item.MaterialStateRetired
    }));
  }

  processData() {
    this.materialData.forEach((material: any) => {
      if (material.MaterialStateRetired == 'True') {
        material.status = 'Inactive';
        material.buttonName = 'Unretire'
      } else {
        material.status = 'Active';
        material.buttonName = 'Retire'
      }
    });
    this.isLoading = false;
  }

  retire(row: any) {
    if (confirm(`Are you sure you want to update a record?`)) {

      let payload = {
        "region": "MaterialState",
        "recID": row.RecID,
        "retired": row.MaterialStateRetired == 'True' ? false : true
      }
      this.adminService.RETIREUSERINTERACTION(payload).subscribe({
        next: (message: any) => {
          this.messageService.showSuccess(message.message);
          this.setMaterialData();
        }
      })
    }
  }

  onInput(event: any): void {
    const input = event.target;
    if (input.value.length > 3) {
      input.value = input.value.slice(0, 3);
      this.ListingPriority = input.value;
    }
  }
  exportToExcel() {
    this.commonService.exportToExcel(this.exportData, 'TLRAdmin-MaterialState.xlsx','TLRAdmin-MaterialState');
    this.messageService.showSuccess("file downloaded successfully" );

  }
  changeNav(){
    this.SaveSuccess = false;
    this.errorData = false;
  }
  addMaterialState() {
    this.errorData = false;
    this.SaveSuccess = false;

    if (this.newMaterialState == '' || this.ListingPriority == '') {
      this.errorData = true;
      this.messageService.showError("Please fill all the fields" );
      return;
    }
    this.isLoading = true;
    let payload = {
      region: "MaterialState",
      data: {
      MaterialStateName: this.newMaterialState,
      MaterialStatePriority: Number(this.ListingPriority), // Convert to number
      FacilityID: this.commonService.getCurrentFacilityId()
      }
    }

    this.adminService.submitUserInteraction(payload).subscribe((response: any) => {
      if (response) {
        this.SaveSuccess = true;
        this.ListingPriority = '';
        this.newMaterialState = '';
        this.messageService.showSuccess("material state added successfully" );

        this.setMaterialData();
      } else {
        this.errorData = true;
      }
    });
  }
}
